import { RSAA } from 'redux-api-middleware';
import fetch from 'isomorphic-fetch';

import api from '../../api';

// ------------------------------------
// Constants
// ------------------------------------
const LOAD_REQUEST = 'farmakom/store/LOAD_REQUEST';
const LOAD_SUCCESS = 'farmakom/store/LOAD_SUCCESS';
const LOAD_FAILURE = 'farmakom/store/LOAD_FAILURE';
const CHANGE_COLOR = 'farmakom/store/CHANGE_COLOR';

// ------------------------------------
// Actions
// ------------------------------------

// API CALL
export function loadStore() {
    return {
        [RSAA]: {
            ...api.getStore(),
            types: [LOAD_REQUEST, LOAD_SUCCESS, LOAD_FAILURE],
            bailout: (store) => store.store.data && store.store.data.datiFarmacia && store.store.data.datiFarmacia.siteName
        }
    }
}

export function changeColor(color) {
    return {
        type: CHANGE_COLOR,
        payload: color
    }
}

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
    loading: false,
    error: '',
    data: {
        home: {},
        messaggiFerie: {},
        datiFarmacia: {},
        funzionalita: {},
        integrazioni: {
            facebook: {},
            google: {},
            trovaprezzi: {},
            feedaty: {}
        },
        loghiTemplate: {},
        notifiche: {},
        costiSpedizione: {
            freeShippingThreshold: 0
        },
        features: {}
    },
    provinces: [
        { code: 'AB', }
    ],
    primaryColor: 'hotpink' //'#66d6be'
};

export default function storeReducer(state = initialState, action) {
    switch (action.type) {
        case LOAD_REQUEST:
            return {
                ...state,
                loading: true
            }
        case LOAD_SUCCESS:
            return {
                ...state,
                loading: false,
                data: {
                    ...state.data,
                    ...action.payload,
                    //freeShippingThreshold: 50
                },
                error: null
            }
        case LOAD_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.message
            }
        case CHANGE_COLOR:
            return {
                ...state,
                data: {
                    ...state.data,
                    loghiTemplate: {
                        ...state.data.loghiTemplate,
                        brandColor: action.payload
                    }
                }
            }
        default:
            return state;
    }
}


  // ------------------------------------
  // Selectors
  // ------------------------------------
